<template>
  <Modal
    v-model="localAddPointVisible"
    title="绑定/添加点位"
    class-name="add-point-modal"
    @on-cancel="cancelModal"
    width="1000px"
  >
    <div class="add-point-box flex-space-between">
      <div class="add-point-left">
        <Form
          ref="addPointFormCustom"
          :model="addPointFormCustom"
          :rules="addPointRuleCustom"
          :label-width="100"
        >
          <FormItem label="回路号" prop="circuitNo">
            <Input
              type="text"
              v-model="addPointFormCustom.circuitNo"
              placeholder="回路号"
            ></Input>
          </FormItem>
          <FormItem label="回路地址号" prop="addressNo">
            <Input
              type="text"
              v-model="addPointFormCustom.addressNo"
              placeholder="回路地址号"
            ></Input>
          </FormItem>
          <FormItem label="设备类型" prop="deviceType">
            <Select
              v-model="addPointFormCustom.deviceType"
              placeholder="设备类型"
              clearable
            >
              <Option
                v-for="(item, index) in localDeviceTypeCode"
                :value="item.value"
                :key="index"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <div style="text-align: right">
            <Button type="primary" @click="handleSubmit('addPointFormCustom')"
              >新建</Button
            >
            <Button
              type="primary"
              @click="handleReset('addPointFormCustom')"
              style="margin-left: 8px"
              >搜索</Button
            >
          </div>
        </Form>
      </div>
      <div class="add-point-right">
        <Table
          border
          ref="selection"
          :columns="columns4"
          :data="pointTableList"
          @on-selection-change="tabSelectChange"
        ></Table>
        <div class="add-point-page">
          <Page
            :total="pages.totalCount"
            :current="pages.currentPage"
            :page-size="pages.pageSize"
            @on-change="changePage"
            @on-page-size-change="pageSizeChange"
            show-sizer
            show-elevator
            show-total
          ></Page>
        </div>
      </div>
    </div>
    <div slot="footer">
      <Button
        @click="cancelModal"
        style="
          background: rgba(231, 231, 231, 0.2);
          border-color: rgba(231, 231, 231, 0.2);
          color: #f3f3f3;
        "
        >返回</Button
      >
      <Button @click="addPointSubmit" type="primary">确定</Button>
    </div>
  </Modal>
</template>

<script>
import axios1 from "@/assets/js/axios1.js";
export default {
  props: {
    addPointVisible: Boolean,
    deviceTypeCode: Array,
    activeTabId: String | Number,
    orgId: String | Number,
    moduleId: String | Number,
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === "" && this.bunState === 1) {
        callback(new Error("请输入回路号"));
      } else {
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "" && this.bunState === 1) {
        callback(new Error("请输入回路地址号"));
      } else {
        callback();
      }
    };
    const validateAge = (rule, value, callback) => {
      if (value === "" && this.bunState === 1) {
        callback(new Error("请选择设备类型"));
      } else {
        callback();
      }
    };
    return {
      localAddPointVisible: false, // 使用本地数据属性
      localDeviceTypeCode: "",
      localActiveTabId: "",
      addPointFormCustom: {
        circuitNo: "",
        addressNo: "",
        deviceType: "",
      },
      addPointRuleCustom: {
        circuitNo: [{ validator: validatePass, trigger: "blur" }],
        addressNo: [{ validator: validatePassCheck, trigger: "blur" }],
        deviceType: [{ validator: validateAge, trigger: "blur" }],
      },
      bunState: 1, //1新建 2搜索
      pages: {
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
      },
      columns4: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          title: "点位名称",
          key: "name",
        },
        {
          title: "点位类型",
          key: "typeName",
        },
        {
          title: "回路号",
          key: "circuitNum",
        },
        {
          title: "回路地址号",
          key: "bitNum",
        },
      ],
      pointTableList: [],
      activeCheckId: "",
    };
  },
  watch: {
    addPointVisible(newValue) {
      this.localAddPointVisible = newValue; // 监听prop的变化并更新本地数据属性
      this.$refs.addPointFormCustom.resetFields();
      this.getTabList(1);
    },
    deviceTypeCode(newValue) {
      this.localDeviceTypeCode = newValue;
    },
    activeTabId(newValue) {
      this.localActiveTabId = newValue;
    },
  },
  methods: {
    cancelModal() {
      this.$emit("addPointUpdate");
      this.localAddPointVisible = false; // 修改本地数据属性
    },
    addPointSubmit() {
      if (this.activeCheckId.length < 1) {
        this.$Message.error("请选择点位");
        return false;
      }
      this.pointSubmit().then((res) => {
        if (res.data.success) {
          this.$emit("addPointUpdate", { aa: "111" });
          this.localAddPointVisible = false; // 修改本地数据属性
        }
      });
    },
    cancel() {
      this.$emit("addPointUpdate");
      this.localAddPointVisible = false; // 修改本地数据属性
    },
    // 获取点位列表
    async getTabList(type) {
      try {
        let params = {
          orgId: this.orgId,
          mainframeId: this.moduleId,
          currentPage: this.pages.currentPage,
          pageSize: this.pages.pageSize,
          hasControlHostDiskFlag: 0,
          partTypeCodes:
            "53,66,48,54,59,29,56,26,60,61,62,64,65,70,24,79,80,72,124,125,126,127,130,131",
        };
        if (type == 1) {
          params.circuitNum = this.addPointFormCustom.circuitNo;
          params.bitNum = this.addPointFormCustom.addressNo;
          params.partTypeCode = this.addPointFormCustom.deviceType;
        } else {
          params.circuitNo = this.addPointFormCustom.circuitNo;
          params.addressNo = this.addPointFormCustom.addressNo;
          params.deviceType = this.addPointFormCustom.deviceType;
        }
        const response = await this.$Axios({
          url: `/mcbw/host_parts`,
          type: "get",
          obj: params,
        });
        if (response.data.success) {
          this.pointTableList = response.data.data;
          this.pages.totalCount = response.data.totalCount;
        }
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 添加点位
    async addTabList(tabType, tabIndex) {
      try {
        let commitData = {
          orgId: this.orgId,
          mainframeId: this.moduleId,
          circuitNo: this.addPointFormCustom.circuitNo,
          addressNo: this.addPointFormCustom.addressNo,
          deviceType: this.addPointFormCustom.deviceType,
        };
        const response = await axios1({
          url: `/mcbw/host_parts`,
          type: "post",
          obj: commitData,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    // 保存函数
    async pointSubmit() {
      try {
        let params = {
          updateControlHostDiskId: this.localActiveTabId,
          mainframeId: this.moduleId,
          ids: this.activeCheckId,
        };
        const response = await this.$Axios({
          url: `/mcbw/host_parts/update_disk`,
          type: "put",
          obj: params,
        });
        return response;
      } catch (err) {
        console.log(err);
      } finally {
      }
    },
    handleSubmit(name) {
      this.bunState = 1;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addTabList().then((res) => {
            this.$Message.success(res.data.message);
            this.getTabList(2);
          });
        }
      });
    },
    handleReset(name) {
      this.bunState = 2;
      //   this.$refs[name].resetFields();
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.getTabList(1);
        }
      });
    },
    tabSelectChange(obj) {
      let ids = [];
      obj.forEach((item) => {
        ids.push(item.id);
      });
      this.activeCheckId = ids.join(",");
    },
    changePage(e) {
      this.pages.currentPage = e;
      this.getTabList(1);
    },
    pageSizeChange(e) {
      this.pages.pageSize = e;
      this.getTabList(1);
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.add-point-modal {
  .add-point-box {
    padding: 20px 0;
    align-items: start;
    .add-point-left {
      width: 38%;
    }
    .add-point-right {
      width: 58%;

      margin-left: 2%;
      position: relative;
      &::before {
        content: "";
        width: 1px;
        height: 120%;
        position: absolute;
        left: -3.5%;
        top: -10%;
        background: #041936;
        box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
      }
      .add-point-page {
        text-align: right;
        margin-top: 10px;
        color: #d9d9d9;
      }
    }
  }
}
/deep/ .add-point-modal {
  .ivu-modal-content {
    background-color: #041936;
    box-shadow: inset 0px 0px 30px 0px rgba(62, 117, 190, 0.5);
    .ivu-modal-header {
      border-bottom: 1px solid #979797;
      .ivu-modal-header-inner {
        color: #eef2f4;
      }
    }
    .ivu-form-item-label {
      color: #74d9ff;
    }
    .ivu-input,
    .ivu-select-selection {
      background: rgba(255, 255, 255, 0.2);
      box-sizing: border-box;
      border: 1px solid #596c87;
      color: #74d9ff;
    }
    .ivu-btn-primary {
      background-color: #1677ff;
    }
    .ivu-table th {
      background-color: #104896;
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }
    .ivu-table td {
      background-color: #041936;
    }
    .ivu-table {
      color: #74d9ff;
    }
    .ivu-table-border td,
    .ivu-table-border th {
      border-right: 1px solid rgba(255, 255, 255, 0.2);
    }
    .ivu-checkbox .ivu-checkbox-inner {
      background-color: rgba(231, 231, 231, 0.5);
    }
    .ivu-table td,
    .ivu-table th,
    .ivu-table-wrapper-with-border {
      border-color: rgba(216, 216, 216, 0.2);
    }
    .ivu-checkbox.ivu-checkbox-checked .ivu-checkbox-inner {
      background-color: #0268fd;
    }
    .ivu-checkbox-checked .ivu-checkbox-inner:after {
      border-color: rgba(255, 255, 255, 0.2);
    }
    .ivu-table-border:after,
    .ivu-table:before {
      background-color: rgba(216, 216, 216, 0.2);
    }
    .ivu-page-next,
    .ivu-page-prev,
    .ivu-page-item,
    .ivu-page-options-elevator input {
      background-color: rgba(255, 255, 255, 0.2);
      border-color: #74d9ff;
      color: #fff;
    }
    .ivu-page-item a {
      color: #d9d9d9;
    }
    .ivu-page-item-active:hover a,
    .ivu-page-item-active a {
      color: #74d9ff;
    }
  }
  .ivu-modal-body {
    padding-top: 15px;
    .show-table-header {
      border-left: 2px solid #02e7e7;
      margin-left: 15px;
      padding-left: 10px;
      .table-header-desc {
        font-size: 18px;
        color: #02e7e7;
      }
      /deep/ .close-btn {
        float: right;
        margin-right: 20px;
        border: 1px solid #08f4f7;
        color: #08f4f7;
        width: 56px;
        height: 28px;
        line-height: 28px;
        cursor: pointer;
        outline: none;
        border-color: rgba(8, 244, 247, 0.3);
        background-color: hsla(0, 0%, 100%, 0.1);
      }
    }
  }
  .ivu-modal-footer {
    border-color: #979797;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/remote-control/add-point.vue